import type { CardTokens } from './types';

export const card: CardTokens = {
  radii: {
    default: 'small',
  },
};
